const CLOUDFLARE_BEACON_URL = 'https://static.cloudflareinsights.com/beacon.min.js'

interface CloudflareAnalyticsConfig {
  isProduction: boolean
  token?: string
}

const defaultConfig: CloudflareAnalyticsConfig = {
  isProduction: import.meta.env.PROD,
  token: import.meta.env.VITE_CLOUDFLARE_WEB_ANALYTICS_TOKEN,
}

/**
 * Adds Cloudflare Web Analytics only to explicitly configured production builds.
 * The site token is a public beacon identifier and is embedded in the built client.
 */
export const initializeCloudflareAnalytics = (
  config: CloudflareAnalyticsConfig = defaultConfig,
): boolean => {
  const token = config.token?.trim()

  if (!config.isProduction || !token || typeof document === 'undefined') {
    return false
  }

  const existingBeacon = document.querySelector<HTMLScriptElement>(
    `script[src="${CLOUDFLARE_BEACON_URL}"]`,
  )

  if (existingBeacon) {
    return false
  }

  const beacon = document.createElement('script')
  beacon.type = 'module'
  beacon.defer = true
  beacon.src = CLOUDFLARE_BEACON_URL
  beacon.dataset.cfBeacon = JSON.stringify({ token })
  document.body.appendChild(beacon)

  return true
}
